import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router non resetta lo scroll tra una rotta e l'altra (a differenza di
// una normale navigazione browser): senza questo, cambiando pagina si resta
// alla stessa posizione di scroll della pagina precedente.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
